import type { CitySchemaType } from '../stepsMap';

import { yupResolver } from '@hookform/resolvers/yup';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';

import { QuestionPageContext } from '../QuestionPageProvider';
import { citySchema } from '../stepsMap';

import StudentQuestion from '$/components/blocks/StudentQuestion';
import Container from '$/components/elements/Container';
import AutocompleteInputQuestion from '$/components/elements/Questions/AutocompleteInputQuestion';
import * as queries from '$/graphql/queries';
import { TRACKING_ACTION } from '$/utils/tracking/consts';

const City = () => {
  const { setCurrentStep, dispatch, state } = useContext(QuestionPageContext);

  const { control, handleSubmit } = useForm<CitySchemaType>({
    mode: 'onChange',
    resolver: yupResolver(citySchema),
    defaultValues: state,
  });

  const onSubmit = (payload: CitySchemaType) => {
    dispatch({
      type: 'set',
      payload,
    });
    setCurrentStep('university');
  };

  return (
    <StudentQuestion noLimitHeight>
      <Container as="form">
        <AutocompleteInputQuestion
          control={control}
          name={'city'}
          title={'Wo studierst du?'}
          placeholder={'Ort'}
          replaceSearch
          query={queries.cityAutoComplete}
          onValueSelected={handleSubmit(onSubmit)}
          maxElements={8}
          searchedFieldElbAction={TRACKING_ACTION.REGISTRATION.STUDIES_CITY}
        />
      </Container>
    </StudentQuestion>
  );
};

export default City;
